import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { GetTransportAreaParams, TransportAreaGet, TransportAreaService } from '@app/services/transport-area.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-transport-area',
    templateUrl: './transport-area.component.html',
    styleUrls: ['./transport-area.component.css'],
})
export class TransportAreaComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetTransportAreaParams;

    public page?: TransportAreaGet;

    public saving = false;

    constructor(
        private transportArea: TransportAreaService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async saveChanges() {
        if (!this.page) return;

        try {
            this.saving = true;

            const response = await this.transportArea.saveTransportArea(this.page);

            if ('' + response.errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.errormessage });
            } else {
                this.navigator?.back(undefined, response);
            }
        } finally {
            this.saving = false;
        }
    }

    private async loadPage() {
        if (!!this.params) {
            this.page = await this.transportArea.getTransportArea(this.params);
        }
    }

    private async init() {
        this.loadPage();
    }

    ngOnInit() {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '60rem' });
            this.params = this.navigator.params as any;

            if (this.params?.transportarea_keyno === '0') {
                this.navigator.setHeading?.('transportareas_new', true);
            } else {
                this.navigator.setHeading?.('p2_m_transportarea', true);
            }
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('transportArea', {
//        templateUrl: 'views/components/views/transportArea/transportArea.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'transportAreaService', function ($stateParams, stateService, modalService, translateService, transportAreaService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let transportAreaKeyno = $stateParams.transportarea_keyno;
//            let stockPlaceId = $stateParams.stockplace_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL

//            async function loadEdit() {
//                vm.model.edit = (await transportAreaService.getEdit({
//                    transportarea_keyno: transportAreaKeyno,
//                    stockplace_id: stockPlaceId
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                transportAreaService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
